import axios, { getData } from 'lib/axios'

// Get all appraisal for individual staff
export const getActiveAppraisalResult = (staffId) => {
  return axios.get(`/performance-active/${staffId}`).then(getData)
}
export const getAllAppraisalResult = (staffId, currentPage) => {
  return axios.get(`/performance/${staffId}?page=${currentPage}`).then(getData)
}

export const getAppraisalResult = (staffId) => {
  return axios.get(`/performance/${staffId}`).then(getData)
}

export const getAppraisalEvaluations = (appraisalId) => {
  return axios.get(`/admin/performance/${appraisalId}`).then(getData)
}

export const getAllEvaluationResult = (staffId, appraisalId) => {
  return axios.get(`/performance/${staffId}/evaluation/${appraisalId}`).then(getData)
}

export const getEvaluationCSV = async (evaluationId) => {
  const res = await axios.get(`admin/performance/evaluation/${evaluationId}/download`, {
    responseType: 'blob',
  })

  return res
}
